// External Imports
import React, { useState } from 'react';

import useWebSocket from 'react-use-websocket';
import env from '../../utils/env';
import PropTypes from 'prop-types';

import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';

//Alert View
export default function QuotaRefresh({ reloadFunction, site }) {
  const [currentStatus, setStatus] = useState('queued');

  const [error, setError] = useState({
    message: 'Waiting for quota to be added to the allowance.',
    severity: 'info',
    waiting: true,
  });

  useWebSocket(env('REACT_APP_WEBSOCKET_URL') + '/quota_status/' + site.customer_id, {
    onMessage: (msg) => {
      try {
        let site_status = undefined;

        const json_msg = JSON.parse(msg.data);
        //console.log(json_msg)

        if ('sites' in json_msg) {
          if (site.site_id in json_msg.sites) {
            site_status = json_msg.sites[site.site_id];
          }
        }
        if (site_status == undefined) {
          return;
        }

        // Check if event was queued already ???
        if (currentStatus == 'queued' && site_status.queued) {
          setStatus('processed');
          setError({
            message: 'Subscription is being re-activated. This can take a few minutes!',
            severity: 'success',
            waiting: true,
          });
          reloadFunction(false);
        }
        // Check if saisei was synched AFTER queue...
        if (currentStatus == 'processed' && site_status.synched) {
          reloadFunction(true);
        }
      } catch (error) {
        setError({ message: error, severity: 'danger', waiting: false });
      }
    },
  });

  return (
    <Alert variant={error.severity}>
      {error.waiting && (
        <Spinner animation='border' role='status'>
          <span className='visually-hidden'>Waiting...</span>
        </Spinner>
      )}
      <span className='ms-2'>{error.message}</span>
    </Alert>
  );
}

QuotaRefresh.propTypes = {
  reloadFunction: PropTypes.func,
  site: PropTypes.object,
};
